import {
    CREATE_PURCHASE_ORDER_SUCCESS,
    FETCH_PURCHASE_ORDER_SUCCESS,
    GET_ALL_UOM_IN_PO_SUCCESS,
    GET_PURCHASE_ORDER_SUCCESS,
    SAVE_PURCHASE_ORDER_QUERY,
    UNMOUNT_PURCHASE_ORDER_SUCCESS,
    GET_GLOBAL_PARAMETER_PO_SEARCH_SUCCESS,
    GET_ASSET_PURCHASE_REPORT_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
    total: 0,
    resources: [],
    resource: {},
    edit: {},
    query: {},
    uomDate: [],
    poSearchData: [],
    assetPurchaseReportData: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SAVE_PURCHASE_ORDER_QUERY: {
            return {
                ...state,
                query: action.query
            }
        }

        case GET_PURCHASE_ORDER_SUCCESS: {
            const query = { ...state.query };
            query.pagination.total = action.count;

            return {
                ...state,
                query: query,
                resources: action.data,
                total: action.total,
            }
        }

        case CREATE_PURCHASE_ORDER_SUCCESS: {
            return {
                ...state,
                resource: action.data,
            }
        }

        case FETCH_PURCHASE_ORDER_SUCCESS: {
            return {
                ...state,
                edit: action.data,
            }
        }

        case GET_ALL_UOM_IN_PO_SUCCESS: {
            return {
                ...state,
                uomData: action.data,
            };
        }

        case UNMOUNT_PURCHASE_ORDER_SUCCESS: {
            return {
                ...state,
                edit: {},
            }
        }

        case GET_GLOBAL_PARAMETER_PO_SEARCH_SUCCESS: {
            return {
                ...state,
                poSearchData: action.data,
            }
        }

        case GET_ASSET_PURCHASE_REPORT_SUCCESS: {
            return {
                ...state,
                assetPurchaseReportData: action.data,
            }
        }


        default:
            return state;
    }
}
